import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { getSessionCountry } from '/@/store/session/selectors';
import Title from '/@/v3/components/title';
import acceleronLogo from '/@/v3/styles/assets/logos/acceleron.svg';
import styles from './styles.module.css';

const Acceleron = (props) => {
    const country = useSelector(getSessionCountry);

    return (
        <Fragment>
            {country.code === 'AR' && props.brand === 'corn' && (
                <div className={styles.footer}>
                    <div className={styles.acceleron}>
                        <img className={styles.logo} src={acceleronLogo} alt='acceleron' />
                        <div className={styles.titles}>
                            <Title size='md' bolder align='justify' theme={settings.app.theme} className={styles.title}>
                                {_(
                                    'Maximiza la emergencia de plántulas, mejora la uniformidad temporal, mayor vigor radicular y aéreo.'
                                )}
                            </Title>
                            <Title size='md' align='justify'>
                                {_(
                                    'Protección frente a enfermedades y contra el daño y la actividad de insectos. Potencia el Rendimiento.'
                                )}
                            </Title>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default Acceleron;
